import { List } from '@faststore/ui'
import { Link } from 'gatsby'
import React from 'react'
import './subcategorie.scss'

interface SubcategorieProps {
  closeMenu?: () => void
  currentCategorie: string
  setCurrentCategorie: (currentCategorie: string) => void
  subCategoriePosition: number
  setSubCategoriePosition: (postion: number) => void
  subcategorie: {
    title: string
    slug: string
  }[]
  categorieTitle: string
  departamentSlug: string
  categorieSlug: string
}

export const Subcategorie = ({
  categorieSlug,
  categorieTitle,
  departamentSlug,
  subcategorie,
  setCurrentCategorie,
  currentCategorie,
  setSubCategoriePosition,
  subCategoriePosition,
  closeMenu,
}: SubcategorieProps) => {
  if (!subcategorie?.length) {
    return null
  }

  return (
    <div className="desktop-menu-subcategorie-items">
      <List>
        {subcategorie
          ?.slice(0, 3)
          .map((item: { title: string; slug: string }, position) => (
            <Link
              onMouseEnter={() => {
                setCurrentCategorie('')
              }}
              onClick={() => {
                setCurrentCategorie(categorieTitle)
                setSubCategoriePosition(position)
                closeMenu?.()
              }}
              key={item?.title}
              to={`/${departamentSlug}/${categorieSlug}/${item.slug}`}
              data-store-link
            >
              <p
                className={
                  categorieTitle === currentCategorie &&
                  subCategoriePosition === position
                    ? 'currentItem'
                    : ''
                }
              >
                {item?.title}
              </p>
            </Link>
          ))}
      </List>
    </div>
  )
}
